import { TransactionEntryTag } from './react/cashflow';
import { SpendingCategoryName } from './types';

export type AmountType = 'spending' | 'income';

export interface MerchantCondition {
    field: 'merchantName';
    matcher: 'equalToInsensitive' | 'includesInsensitive';
    value: string;
}

export interface StatementCondition {
    field: 'statement';
    matcher: 'equalToInsensitive' | 'includesInsensitive';
    value: string;
}

export interface AmountRangeCondition {
    field: 'amount';
    matcher: 'between';
    value: [number, number];
    amountType: AmountType;
}

export interface AmountComparisonCondition {
    field: 'amount';
    matcher: 'equalTo' | 'greaterThan' | 'lessThan';
    value: number;
    amountType: AmountType;
}

export interface CategoryCondition {
    field: 'categoryId';
    matcher: 'equalTo';
    value: string;
}

export interface FinancialEntityCondition {
    field: 'financialEntityId';
    matcher: 'equalTo';
    value: string;
}

export type RuleCondition =
    | MerchantCondition
    | StatementCondition
    | AmountRangeCondition
    | AmountComparisonCondition
    | CategoryCondition
    | FinancialEntityCondition;

export type RuleConditions = RuleCondition[];

export interface MerchantChange {
    field: 'merchantId';
    value: string;
}

export interface CategoryChange {
    field: 'categoryId';
    value: string;
}

export interface TagChange {
    field: 'tagNames';
    value: string[];
}

export interface HiddenChange {
    field: 'isHidden';
    value: boolean;
}

export type RuleChange =
    | MerchantChange
    | CategoryChange
    | TagChange
    | HiddenChange;

export type RuleChangeset = RuleChange[];

const DARK_RED = '#BA175A';
const LIGHT_RED = '#DA4B5B';
const ORANGE = '#F46D43';
const YELLOW = '#E6DB48';
const DARK_GREEN = '#66C2A5';
const LIGHT_GREEN = '#ABDDA4';
const DARK_BLUE = '#3288BD';
const LIGHT_BLUE = '#6DB4E1';
const LIGHT_PURPLE = '#998DCD';
const DARK_PURPLE = '#5E4FA2';

export const TAG_COLORS: string[] = [
    DARK_RED,
    LIGHT_RED,
    ORANGE,
    YELLOW,
    DARK_GREEN,
    LIGHT_GREEN,
    DARK_BLUE,
    LIGHT_BLUE,
    LIGHT_PURPLE,
    DARK_PURPLE,
];

export const DEFAULT_TAGS: TransactionEntryTag[] = [
    {
        name: 'For Review',
        color: ORANGE,
    },
    {
        name: 'Reviewed',
        color: DARK_GREEN,
    },
    {
        name: 'Needs',
        color: LIGHT_BLUE,
    },
    {
        name: 'Wants',
        color: LIGHT_PURPLE,
    },
];

// Maps our category group names to the spending categories from the Bureau of Labor Statistics
export const CATEGORY_GROUP_SPENDING_CATEGORY_MAP: Record<
    string,
    SpendingCategoryName
> = {
    'Food and Drink': 'Food & Beverage',
    Housing: 'Housing',
    Transportation: 'Transportation',
    'Health and Wellness': 'Healthcare',
};
